module.exports = __webpack_public_path__ + "img/qz-mobile.3915be39.png";